<template>
  <div>
    <Header :code="code" :team_id="team_id" points="-" />

    <div class="game-texture-layer"></div>

    <!-- pre logout message -->
    <section class="cont-fullwidth black-bg">
      <div class="row pt-5">
        <div class="col-12 d-flex white-text">
          <div class="flex-fill">
            <h2 class="termina-black">
              You are about to Log Out.<br /><br />
              Are you sure you want to<br />leave the game?
            </h2>
          </div>
        </div>
      </div>
    </section>

    <!-- logout link -->
    <router-link
      :to="{
        name: 'create-team',
        params: { code: this.code }
      }"
    >
      <div class="cont-fullwidth white-text" style="background: #BB202F">
        <div class="row pt-5">
          <div class="col-12">
            <h2 class="termina-black">Yes , Log Out</h2>
          </div>
        </div>
      </div>
    </router-link>

    <!-- go back to game link -->
    <a style="cursor: pointer" @click="handleGoBack">
      <div class="cont-fullwidth white-text" style="background: #2E2020">
        <div class="row pt-5">
          <div class="col-12">
            <h2 class="termina-black">No... take me back</h2>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'

export default {
  components: {
    Header
  },
  props: {
    code: { type: String, required: true },
    team_id: { type: String, required: true }
  },
  beforeRouteEnter(to, from, next) {
    if (to || from) {
      document.body.classList.add('black-bg')
    }

    next()
  },
  beforeRouteLeave(to, from, next) {
    if (to || from) {
      document.body.classList.remove('black-bg')
    }
    next()
  },
  data: () => ({}),
  methods: {
    handleGoBack() {
      if (window.history.length > 2) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>
<style scoped></style>
